export default {
    methods: {
        getCurrentUser: function () {
            return localStorage.getObject("auth-user-juniper");
        },
        userHasAllNeededJuniperPermissions(permissions) { // permissions is array 
            let currentUser = this.getCurrentUser();
            if (!currentUser) {
                return false;
            }
            if (!currentUser.roles) {
                return false;
            }

            if (currentUser.roles.includes("SuperAdmin")) {
                return true;
            }

            return permissions.every(permission => currentUser.permissions.includes(permission));
        },
        userHasOneOfNeededJuniperPermissions(permissions) { // permissions is array 
            let currentUser = this.getCurrentUser();
            if (!currentUser) {
                return false;
            }
            if (!currentUser.roles) {
                return false;
            }

            if (currentUser.roles.includes("SuperAdmin")) {
                return true;
            }

            return permissions.some(permission => currentUser.permissions.includes(permission));
        },
    },
};
